"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const BOMItemsGroup_1 = __importDefault(require("./BOMItemsGroup"));
exports.default = BOMItemsGroup_1.default;
